import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConversationChat1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.25,18.75a1.5,1.5,0,0,1-1.5-1.5V9.75a1.5,1.5,0,0,1,1.5-1.5h10.5a1.5,1.5,0,0,1,1.5,1.5v7.5a1.5,1.5,0,0,1-1.5,1.5h-1.5v4.5l-4.5-4.5Z",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.75,12.75l-3,3v-4.5H2.25a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75h10.5a1.5,1.5,0,0,1,1.5,1.5v3",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5
	})]
});
export default SvgConversationChat1;
